// Primitive/Skeleton (Figma 9:10) — what frame 08 (33:2208) is built from.
//
// A FLAT SOLID --bg-inset rectangle. No shimmer, no gradient, no animation:
// the drawn primitive is a plain fill, and there is no design authority
// anywhere in the file for a moving one. Inventing a shimmer here would be a
// component the designer never drew.
//
// Two shapes, both measured off the real instances:
//   line  — 12px tall, radius-sm, 160px default width
//   block — 64px tall, radius-md, full width
// Frame 08 composes them at explicit sizes (280x28 title, 620x12 + 452x12
// body lines, 96x32 + 128x32 action placeholders), which is why width and
// height are both overridable.

import "./ui.css";
import type { ReactNode } from "react";

export type SkeletonProps = {
  shape?: "line" | "block";
  width?: number | string;
  height?: number;
};

export function Skeleton({ shape = "line", width, height }: SkeletonProps) {
  const fallbackWidth = shape === "line" ? 160 : "100%";
  return (
    <span
      className="maisight-ui-skeleton"
      data-shape={shape}
      aria-hidden="true"
      style={{
        width: width ?? fallbackWidth,
        height: height ?? (shape === "line" ? 12 : 64),
      }}
    />
  );
}

export type SkeletonStackProps = {
  /** Announced while the real content loads — individual bars are hidden. */
  label?: string;
  children: ReactNode;
};

export function SkeletonStack({
  label = "Loading",
  children,
}: SkeletonStackProps) {
  return (
    <div className="maisight-ui-skeleton-stack" role="status" aria-label={label}>
      {children}
    </div>
  );
}
